module.exports = __webpack_public_path__ + "img/event.206648d4.jpg";